import React from 'react';
import Sof from './sections/Sof';
import Deposit from './sections/Deposit';
import Portfolio from './sections/Portfolio';
import Tof from './sections/Tof';

const sof = (props, role, isExecuted, setInvalid, endDate, onLoad) => {
  return (
    <Sof
      {...props}
      canEdit={role.can_edit}
      isExecuted={isExecuted}
      setInvalid={setInvalid}
      endDate={endDate}
      onLoad={onLoad}
    />
  );
};

const deposit = (props, role, isExecuted, setInvalid, endDate, onLoad) => {
  return (
    <Deposit
      {...props}
      canEdit={role.can_edit}
      isExecuted={isExecuted}
      setInvalid={setInvalid}
      endDate={endDate}
      onLoad={onLoad}
    />
  );
};

const portfolio = (props, role, isExecuted, setInvalid, endDate, onLoad) => {
  return (
    <Portfolio
      {...props}
      canEdit={role.can_edit}
      isExecuted={isExecuted}
      setInvalid={setInvalid}
      endDate={endDate}
      onLoad={onLoad}
    />
  );
};

const tof = (props, role, isExecuted, setInvalid, endDate, onLoad) => {
  return (
    <Tof
      {...props}
      canEdit={role.can_edit}
      isExecuted={isExecuted}
      setInvalid={setInvalid}
      isLastPerson={role.priority === 4}
      endDate={endDate}
      onLoad={onLoad}
    />
  );
};

export default { sof, deposit, portfolio, tof };
